import { Component, ElementRef, EventEmitter, forwardRef, HostBinding, HostListener, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { NumberService } from 'src/app/service/util/number.service';
import { CalendarPopoverComponent } from '../calendar-popover/calendar-popover.component';
const noop = () => {};

@Component({
  selector: 'app-calendar-input',
  templateUrl: './calendar-input.component.html',
  styleUrls: ['./calendar-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CalendarInputComponent),
    multi: true
  }]
})
export class CalendarInputComponent implements ControlValueAccessor {

  @Input() label:string = "";
  @Input() min;
  @Input() max;
  @Input() disableDaysOfWeek = [];
  @Output() change = new EventEmitter();

  form = {
    year: '',
    month: '',
    date: ''
  }

  constructor(
    private elRef: ElementRef,
    private popover: PopoverController,
    private number: NumberService
  ) {

  }

  changeYear(ev) {
    if(this.form.year) {
      if(this.form.year.length < 4) {
        this.form.year = this.number.fix(this.form.year, 4, 0, 3000);
      }
      else if(ev.key.length === 1) {
        this.form.year = this.number.fix(this.form.year + ev.key, 4, 0, 3000);
      }
      else if(ev.key === 'Backspace') {
        this.form.year = this.number.fix(this.form.year.slice(0, -1), 4, 0, 3000);
      }
    }
    this.onChangeCallback(this.getDateFormat());
  }
  changeMonth(ev) {
    if(this.form.month) {
      if(this.form.month.length < 2) {
        this.form.month = this.number.fix(this.form.month, 2, 0, 12);
      }
      else if(ev.key.length === 1) {
        this.form.month = this.number.fix(this.form.month + ev.key, 2, 0, 12);
      }
      else if(ev.key === 'Backspace') {
        this.form.month = this.number.fix(this.form.month.slice(0, -1), 2, 0, 12);
      }
    }
    this.onChangeCallback(this.getDateFormat());
  }
  changeDate(ev) {
    if(this.form.date) {
      if(this.form.date.length < 2) {
        this.form.date = this.number.fix(this.form.date, 2, 0, 31);
      }
      else if(ev.key.length === 1) {
        this.form.date = this.number.fix(this.form.date + ev.key, 2, 0, 31);
      }
      else if(ev.key === 'Backspace') {
        this.form.date = this.number.fix(this.form.date.slice(0, -1), 2, 0, 31);
      }
    }
    this.onChangeCallback(this.getDateFormat());
  }
  getDateFormat() {
    return this.number.fix(this.form.year, 4) + '-' + this.number.fix(this.form.month, 2) + '-' + this.number.fix(this.form.date, 2);
  }
  async popoverCalendar() {
    console.log("popoverCalendar min:" + this.min + ' , max:' + this.max);
    console.log("disableDaysOfWeek :" + this.disableDaysOfWeek);

    const event:any = {target: this.elRef.nativeElement}
    let date = null;
    if(Number(this.form.year) > 1920) {
      const valueDateArr = this.getDateFormat().split('-');
      date = new Date(Number(valueDateArr[0]), Number(valueDateArr[1])-1, Number(valueDateArr[2]));
      date = isNaN(date.getTime()) ? new Date() : date;
    }
    const popover = await this.popover.create({
      cssClass: 'calendar-popover',
      component: CalendarPopoverComponent,
      componentProps: {
        min: this.min,
        max: this.max,
        value: date,
        disableDaysOfWeek: this.disableDaysOfWeek
      },
      event,
      showBackdrop: false
    });
    popover.present();
    const { data } = await popover.onWillDismiss();
    if(data) {
      this.value = data.getFullYear() + '-' + this.number.fix(data.getMonth() + 1, 2) + '-' + this.number.fix(data.getDate(), 2);
    }
  }


  //기본 셋팅(엔간해선 건드릴 일은 없음)
  get value() { return this.getDateFormat(); };
  set value(v) {
    if (v !== this.getDateFormat()) {
      try {
        const numArr = v.split('-');
        this.form.year = numArr[0];
        this.form.month = numArr[1];
        this.form.date = numArr[2];
      } catch(e) {
        this.form.year = null;
        this.form.month = null;
        this.form.date = null;
      }
      this.onChangeCallback(v);
      this.change.emit(v);
    }
  }
  writeValue(v: any) {
    if (v !== this.getDateFormat()) {
      try {
        const numArr = v.split('-');
        this.form.year = numArr[0];
        this.form.month = numArr[1];
        this.form.date = numArr[2];
      } catch(e) {
        this.form.year = null;
        this.form.month = null;
        this.form.date = null;
      }
    }
  }

  @Input() readonly:string | boolean = false; 
  @Input() set disabled(v) {
    if(v === false || v === 'false') this.readonly = false;
    else this.readonly = true;
  }
  get disabled() { return this.readonly; }
  @HostBinding('class.disabled') get classDisabled() { return this.readonly }

  //뭔지모르는 애들
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  registerOnChange(fn: any) { this.onChangeCallback = fn; }
  registerOnTouched(fn: any) { this.onTouchedCallback = fn; }
  onBlur() { this.onTouchedCallback(); }

}
